import { Icon } from '@iconify/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContactInfoWidget() {
  const { t, ready } = useTranslation();
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ic:baseline-whatsapp" />
        </i>
        <a href="https://api.whatsapp.com/send?phone=302112340748" target="_blank" rel="noopener noreferrer">+302112340748</a>
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        <a href="tel:+302112340748" target="_blank" rel="noopener noreferrer">+302112340748 ({t('free_call')})</a>
      </li>
      
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        <a href="mailto:info@gestlifesurrogacy.com">info@gestlifesurrogacy.com</a>
      </li>
    </ul>
  );
}
 